import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff9e5",
      d: "M0 8a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#ffa000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M23.75 10.85v12.3a.6.6 0 0 1-.6.6h-12.3a.6.6 0 0 1-.6-.6v-12.3a.6.6 0 0 1 .6-.6h12.3a.6.6 0 0 1 .6.6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#ffa000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14 12.5s-1.875 2.25 0 4.5 0 4.5 0 4.5M17 12.5s-1.875 2.25 0 4.5 0 4.5 0 4.5M20 12.5s-1.875 2.25 0 4.5 0 4.5 0 4.5"
    }, null, -1)
  ]))]))
}
export default { render: render }